import React from "react";
import { WBMFormatMoney } from "wbm-format-money";

const Budget = ({ availableBudget, remainingBudget }) => {
  return (
    <>
      <div className="row available-budget">
        <div className="col-6 text-left-no-padding-left">
          <span>Available Budget</span>
        </div>
        <div className="col-6 text-right no-padding-right">
          <WBMFormatMoney
            isFancy
            amount={availableBudget}
            className="font-weight-bold"
          />
        </div>
      </div>
      <div className="row form-group">
        <div className="col-6 text-left-no-padding-left">
          <span>Remaining Budget</span>
        </div>
        <div className="col-6 text-right no-padding-right">
          <WBMFormatMoney
            isFancy
            amount={remainingBudget}
            className={
              "font-weight-bold budget-" +
              (remainingBudget >= 0 ? "success" : "failure")
            }
          />
        </div>
      </div>
    </>
  );
};

export default Budget;
